// Module
var code = "<div class=\"modal-body\"> <span>{{refreshReferenceDataProgressMessage}}</span> <div class=\"progress\"> <div class=\"progress-bar progress-bar-striped bg-success\" role=\"progressbar\" style=\"width:{};\" aria-valuenow=\"{{refreshReferenceDataProgressPercentage}}\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div> </div> </div> ";
// Exports
module.exports = code;